import React from 'react';

import { RequestStepperProps } from './models';

import { TickCircle } from 'iconsax-react';

const RequestStepper = ({ steps, currentStep }: RequestStepperProps) => {
    return (
        <nav aria-label='مراحل ثبت درخواست' className='px-4 pb-4 pt-1'>
            <ol className='m-0 flex list-none items-start p-0'>
                {steps.map((step, index) => {
                    const stepNumber = index + 1;
                    const isDone = stepNumber < currentStep;
                    const isCurrent = stepNumber === currentStep;

                    return (
                        <li
                            key={step.id}
                            aria-current={isCurrent ? 'step' : undefined}
                            className='relative flex flex-1 flex-col items-center gap-1.5'>
                            {index < steps.length - 1 && (
                                <span aria-hidden className={`absolute right-1/2 top-3.5 h-0.5 w-full ${isDone ? 'bg-white' : 'bg-white/30'}`} />
                            )}
                            <span
                                className={`relative z-10 flex h-7 w-7 items-center justify-center rounded-full border-2 border-solid text-xs
                                font-bold ${
                                    isDone
                                        ? 'border-white bg-white text-primary'
                                        : isCurrent
                                          ? 'border-white bg-white text-primary shadow-[0_0_0_4px_rgba(255,255,255,0.25)]'
                                          : 'border-white/50 bg-primary text-white/70'
                                }`}>
                                {isDone ? <TickCircle size={18} variant='Bold' color='currentColor' /> : stepNumber.toLocaleString('fa-IR')}
                            </span>
                            <span className={`text-center text-[10px] leading-4 ${isCurrent ? 'font-bold text-white' : 'text-white/70'}`}>
                                {step.title}
                            </span>
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};

export default RequestStepper;
